import { ComponentProps, ReactNode } from 'react';
import {
	SettingItemControl,
	SettingItemContainer,
	SettingItemDescription,
	SettingItemContainerForm,
} from 'shared/_ui/settings-item/styles';

type SettingsItemProps = Omit<ComponentProps<typeof SettingItemContainer>, 'as'> & {
	as?: Omit<ComponentProps<typeof SettingItemContainer>['as'], 'form'>;
	control?: ReactNode;
};
type SettingsItemPropsForm = Omit<ComponentProps<typeof SettingItemContainerForm>, 'as'> & {
	as?: 'form';
	control?: ReactNode;
};

function SettingsItem(props: SettingsItemProps): JSX.Element;
function SettingsItem(props: SettingsItemPropsForm): JSX.Element;
function SettingsItem(props: SettingsItemProps | SettingsItemPropsForm): JSX.Element {
	const { children, control, ...rest } = props;

	const containerChildren = (
		<>
			<SettingItemDescription>{children}</SettingItemDescription>
			{!!control && <SettingItemControl>{control}</SettingItemControl>}
		</>
	);

	if (rest.as === 'form') {
		return (
			<SettingItemContainerForm {...(rest as ComponentProps<typeof SettingItemContainerForm>)}>
				{containerChildren}
			</SettingItemContainerForm>
		);
	}

	return (
		<SettingItemContainer {...(rest as ComponentProps<typeof SettingItemContainer>)}>
			{containerChildren}
		</SettingItemContainer>
	);
}

export default SettingsItem;
